export default __webpack_public_path__ + "static/media/Ribbon App.2c4e83e5.png";